
import { Vue, Component, Prop } from "vue-property-decorator";
import S3Image from "@/components/common/s3-image.vue";


@Component({
  components: {
    S3Image,
  }
})
export default class ItemsRenderer extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: {id:string | number, name: string}[];
  @Prop({ type: String, required: false, default: 'Items' }) readonly title!: string;
  @Prop({ type: String, required: false, default: '' }) readonly content_class!: string;
  @Prop({ type: String, required: false, default: '' }) readonly chipClass!: string;
  @Prop({ type: Number, required: false, default: 3}) readonly showMoreAfter!: number;
  @Prop({ type: Boolean, required: false, default: false}) readonly showAll!: boolean;
  @Prop({ type: Boolean, required: false, default: false}) readonly fullItem!: boolean;

  get showMoreOption(){
    return !this.showAll && this.items.length > this.showMoreAfter
  }
  get chipsClasses(){
    return `${this.fullItem? 'full_item': ''} ${this.chipClass}`
  }
  get getContentClasses(){
    return `${this.fullItem? 'flex-wrap': ''} ${this.content_class}`
  }

get getItems(){
  if(this.showAll){
    return this.items
  }

  return this.items.slice(0, this.showMoreAfter)
}
}

